var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovingIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 33.1C79.6 31.7 83.8 30.3 87.6 28.7C91.3 27.1 95.7 25.6 98.2 22.3L98.8 21.5C98.4 25.3 97.8 29 96.4 32.5C95 35.8 92.8 38.9 89.4 40.4L89.9 39.5C90.3 44.7 87.4 49.8 82.8 52.1L83.1 51.5C83.3 54 82.3 56.6 80.3 58.1L80.2 58C81.8 56.3 82.5 54 82 51.8L81.9 51.4L82.2 51.2C85.1 49.3 87.2 46.4 87.8 43C88.1 41.7 88.2 40.3 88.1 39C91.4 37.9 93.6 35 95.1 31.9C96.6 28.9 97.7 25.7 98.1 22.4L98.6 22.6C94.3 27.6 88.2 30.6 82 32.2C79.9 32.7 77.8 33.1 75.7 33.4C75.8 33.2 75.7 33.1 75.7 33.1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 33.2C15.7 32.2 6.89998 29.1 1.19998 22.4L1.69998 22.2C2.69998 28.2 5.29997 35.9 11.2 38.6L11.8 38.8C11.7 40.1 11.8 41.4 12.1 42.8C12.8 46.2 14.8 49.1 17.7 51L18 51.2L17.9 51.6C17.5 53.8 18.2 56.2 19.7 57.8L19.6 57.9C17.5 56.4 16.5 53.8 16.8 51.3L17.1 51.9C14.9 50.8 12.9 48.9 11.7 46.7C10.4 44.4 9.79998 41.9 9.99998 39.3L10.5 40.2C5.49998 38 3.09998 32.5 1.99998 27.4C1.59998 25.4 1.29998 23.4 1.09998 21.3L1.69998 22.1C2.89998 23.8 4.69998 25 6.59998 26C10.4 27.9 14.3 29.4 18.3 30.9L21.3 32C22.3 32.4 23.3 32.7 24.3 33.1L24.2 33.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 28.2C26.9 28.2 62.1 25.4 74.4 29.7C74.4 29.7 76.1 70.6 73.4 77C73.4 77 40.4 79.2 25.3 75.7C25.3 75.6 23.9 33.7 26.9 28.2Z",
    fill: "#FFF4DE",
    stroke: "#FFF4DE",
    strokeWidth: 2.4959,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63.9H53.9V73.1H70V63.9Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 2.1631,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8 41.3L50.6 38.4L45.7 41.3V27.1H55.8V41.3Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 2.1631,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7 48.7L56.2 49C56.2 49 59.1 48.9 59 51.3C58.9 53.2 57.7 53.4 56.7 53.5C55.7 53.6 44.3 53.4 44.3 53.4C44.3 53.4 41.1 53.3 41.2 51.1C41.2 49 42.7 48.7 44.7 48.7Z",
    stroke: "#101C1E",
    strokeWidth: 1.248,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovingIn);
export default __webpack_public_path__ + "static/media/moving-in.d70ee239debca970d0a87d1075883939.svg";
export { ForwardRef as ReactComponent };